import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';

import {
  selectSponsoredOffersConfig,
  makeselectSponsoredOffersDataToDisplay,
  makeselectSponsoredOffersIsLoaded,
  makeselectSponsoredOffersIsLoading,
} from 'core/modules/SponsoredOffers/selectors';

export const useGetSponsoredOffers = (namespace, customApiParams) => {
  const dispatch = useDispatch();
  const selectSponsoredOffersDataToDisplay = useMemo(makeselectSponsoredOffersDataToDisplay, []);
  const selectSponsoredOffersIsLoaded = useMemo(makeselectSponsoredOffersIsLoaded, []);
  const selectSponsoredOffersIsLoading = useMemo(makeselectSponsoredOffersIsLoading, []);

  const data = useSelector(state => selectSponsoredOffersDataToDisplay(state, namespace));
  const config = useSelector(selectSponsoredOffersConfig);
  const isLoaded = useSelector(state => selectSponsoredOffersIsLoaded(state, namespace));
  const isLoading = useSelector(state => selectSponsoredOffersIsLoading(state, namespace));

  const { api: { params, options } } = config;

  const callFetchPlacements = () => {
    const actualParams = { ...params, ...customApiParams };

    dispatch(fetchPlacements(actualParams, { ...options, namespace }));
    return true;
  };

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      callFetchPlacements();
    }
  });

  return {
    data,
    config,
  };
};
